import dynamic from 'next/dynamic';
import { ModuleBase, Text, HeadingTag } from '@/components';
import { isColorDark } from '@/utils';
import classNames from 'classnames';
import ViewerLoader from '@/components/general/pdf/ViewerLoader';

const PdfViewer = dynamic(() => import('@/components/general/pdf/PdfViewer'), {
  ssr: false,
  loading: () => <ViewerLoader className="h-[70vh] max-h-[760px] min-h-[460px] rounded-sm" />,
});

const DocumentViewerModule = ({ data }) => {
  const {
    headingTitle,
    description,
    document,
    documentName,
    documentExtension,
    documentSizeBytes,
    viewMode,
    viewerHeight,
    coverInSpread,
    disableDownload,
    downloadLabel,
  } = data || {};

  const dark = isColorDark(data?.backgroundColour);
  const pdfUrl = document?.imageUrl;

  if (!pdfUrl) {
    return null;
  }

  return (
    <ModuleBase data={data}>
      <div className="container px-6 md:px-10">
        <div className="mx-auto max-w-[1400px]">
          {(headingTitle?.heading || description) && (
            <div className="mb-8 text-center">
              {headingTitle?.heading && (
                <HeadingTag
                  animate
                  data={headingTitle}
                  className="color-from-bg mb-4 font-larken text-2xl font-light leading-7 md:text-desktop-medium md:leading-desktop-medium"
                />
              )}
              {description && (
                <Text
                  dangerouslySetInnerHTML={{ __html: description }}
                  className={classNames(
                    'richtext-content mx-auto max-w-[720px] font-gotham text-small-paragraph font-s-light leading-6 [&_a]:underline [&_p:last-child]:mb-0 [&_p]:mb-4',
                    dark ? 'text-white/75' : 'text-black/75',
                  )}
                />
              )}
            </div>
          )}

          <PdfViewer
            url={pdfUrl}
            fileName={documentName}
            fileExtension={documentExtension}
            fileSizeBytes={documentSizeBytes}
            defaultViewMode={viewMode}
            viewerHeight={viewerHeight || 'standard'}
            coverIsSinglePage={!coverInSpread}
            allowDownload={!disableDownload}
            downloadLabel={downloadLabel}
            dark={dark}
          />
        </div>
      </div>
    </ModuleBase>
  );
};

export default DocumentViewerModule;
